import React, { useState, useEffect } from "react";
import { Tag, DeleteButton, Text, EntityLabel } from "./Styled";
import { Popover } from "antd";
import { useSelector } from "react-redux";
import EntitySelector from "../EntitySelector/EntitySelector";
import { RootState } from "../../../../../model/rootReducer";
import { Entity } from "../../../../../model/intent/types";

const Mark = (props: any) => {
  const entities: Array<Entity> = useSelector((state: RootState) => state.entity.entities);
  const { entityId } = props.contentState.getEntity(props.entityKey).getData();
  const labelEntity = entities.find(entity => entity.id === entityId);
  const [isOpen, setOpen] = useState(false);

  const remove = () => {
    props.onRemoveEntity(props.blockKey, props.start, props.end);
  };

  const change = (entity: Entity) => {
    setOpen(false);
    props.unlock()
    props.onChangeEntity(entity.id, props.entityKey);
  };

  const openPopOver = (isOpen: boolean) => {
    if(isOpen){
      props.lock()
    } else {
      props.unlock()
    }
    setOpen(isOpen);
  }

  return (
    <Popover
      trigger="focus"
      content={<EntitySelector entities={entities} onSelect={(entity) => change(entity)} />}
      visible={isOpen}
      onVisibleChange={() => openPopOver(!isOpen)}
    >
      <Tag color={labelEntity?.color}>
        <span onClick={() => openPopOver(!isOpen)}>
        <Text>{props.children}</Text>
        <EntityLabel>{labelEntity?.title}</EntityLabel>
        </span>
        <DeleteButton onClick={remove}>x</DeleteButton>
      </Tag>
    </Popover>
  );
};

export default React.memo(Mark);